// JPA-8241: writeText rejects when the document isn't focused at that moment (e.g. a tab left
// open for hours before the user comes back and clicks copy). Nothing awaited that rejection, so
// it surfaced as an unhandled promise rejection crash.
const copyToClipboard = async (value: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    return false;
  }
};

export default copyToClipboard;
